/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Subheading_2Inputs */

const et_contact_subheading_2 = /** @type {(inputs: Contact_Subheading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Töötame ühe ettevõttega linna ja valdkonna kohta.`)
};

const en_contact_subheading_2 = /** @type {(inputs: Contact_Subheading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We work with one business per city and industry.`)
};

/**
* | output |
* | --- |
* | "We work with one business per city and industry." |
*
* @param {Contact_Subheading_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_subheading_2 = /** @type {((inputs?: Contact_Subheading_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Subheading_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_subheading_2(inputs)
	return en_contact_subheading_2(inputs)
});